const initialState = {
  isLogoutTiming: false,
};

export default initialState;
